module.exports = __webpack_public_path__ + "static/media/acpi-logo white.e917fe60.svg";